import { useEffect, useState } from "react";
import "../styles/Siniestro.css";
import { Accordion } from "react-bootstrap";
import { ButtonNextSiniestro, ButtonPreviousSiniestro } from "../../../../assets/icons/Icons";

const Siniestro = ({ siniestros, pasosSiniestros }) => {
  const [tabs, setTabs] = useState([]);
  const [contenido, setContenido] = useState([]);
  const [pestañaActiva, setPestañaActiva] = useState(null); // Para manejar la pestaña activa
  const [paginaActual, setPaginaActual] = useState(0); // Para manejar la paginación

  useEffect(() => {
    if (siniestros) {
      setTabs(siniestros);
      setContenido(pasosSiniestros);

      if (siniestros.length > 0) {
        seleccionarPestaña(siniestros[0].id);
      }
    }
  }, [siniestros, pasosSiniestros]);

  const seleccionarPestaña = (idPestaña) => {
    setPestañaActiva(idPestaña);
    // Resetear la página actual cuando se selecciona una nueva pestaña
  };

  const cambiarPagina = (direccion) => {
    const nuevaPagina = paginaActual + direccion;
    if (nuevaPagina >= 0 && nuevaPagina < Math.ceil(tabs.length / 4)) {
      // Determina el primer tab de la nueva página
      const primerTabNuevaPagina = nuevaPagina * 4;
      setPaginaActual(nuevaPagina);
      // Establece el primer tab de la nueva página como activo
      seleccionarPestaña(tabs[primerTabNuevaPagina].id);
    }
  };

  return (
    <div className="container ps-0 pe-0">
      <div
        className="homeout__coberturas m-auto pt-lg-5 mt-lg-5"
        id="siniestro"
        style={{ paddingBottom: "0rem" }}
      >
        <h2 className="pe-3 ps-3">Reporta un siniestro</h2>
        <p className="pe-3 ps-3 d-none d-lg-block" style={{ fontSize: "1.5rem" }}>
          Reúne los documentos abajo listados y contáctanos vía{" "}
          <span
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>Whatsapp</b>
          </span>{" "}
          al{" "}
          <span
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>55 7500 3746</b>
          </span>{" "}
          o comunícate al{" "}
          <span
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>800 801 2402</b>
          </span>{" "}
          de lunes a viernes de <br/>
          08:00 a 21:00 hrs. Aquí te ayudaremos a
          continuar con tu proceso de reclamo de siniestro.
        </p>

        <p className="d-block d-lg-none" style={{ fontSize: "1.8rem", padding: "0 7%" }}>
          Reúne los documentos abajo listados y contáctanos vía{" "}
          <span
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>Whatsapp</b>
          </span>{" "}
          al{" "}
          <a
            href="https://wa.me/5215575003746"
            target="_blank"
            rel="noreferrer"
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>55 7500 3746</b>
          </a>{" "}
          o comunícate al{" "}
          <a
            href="tel:8008012402"
            style={{ color: "var(--rojo)", fontFamily: "var(--fuente-bold)" }}
          >
            <b>800 801 2402</b>
          </a>{" "}
          de
          lunes a viernes de
          08:00 a 21:00 hrs. Aquí te ayudaremos a
          continuar con tu proceso de reclamo de siniestro.
        </p>

        {/* VERSION MOBILE */}
        <div className="pt-5 d-block d-lg-none">
          <Accordion defaultActiveKey="0" flush>
            {siniestros &&
              siniestros.map((siniestro, index) => {
                let pasoFiltrados = pasosSiniestros.filter(
                  (ps) => ps.idTabSiniestro === siniestro.id
                );
                return (
                  <Accordion.Item eventKey={String(index)}>
                    <Accordion.Header className="accordion__header__siniestro">
                      <div className="header__accordion" dangerouslySetInnerHTML={{__html:siniestro.tituloTab}}>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div
                        style={{ marginBottom: "2rem", marginTop: "2rem" }}
                        className="texto__siniestro__div"
                      >
                        <br />
                        <ol className=" texto__siniestro list-group-numbered">
                          {pasoFiltrados.map((paso, indexPaso) => {
                            return (
                              <li className="list-group-item d-flex justify-content-between align-items-start">
                                <div
                                  className="ms-2 me-auto paso__siniestro"
                                  style={{ textAlign: "justify" }}
                                >
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: paso.descripcionPaso,
                                    }}
                                  ></p>
                                </div>
                              </li>
                            );
                          })}
                        </ol>
                        <p>
                          En casos extraordinarios si no nos es posible demostrar la procedencia del Evento, 
                          solicitaremos más información sobre los hechos relacionados con éste. 
                        </p>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
          </Accordion>
        </div>

        {/* VERSION DESKTOP */}
        <div className="col-lg-7 d-none d-lg-block body__siniestro">
          <div>
            <ul id="pr" className="nav nav-perfil-links">
              <button
                onClick={() => cambiarPagina(-1)}
                disabled={paginaActual === 0}
                className={
                  paginaActual === 0
                    ? "button_siniestros button_disabled"
                    : "button_siniestros"
                }
              >
                <ButtonPreviousSiniestro />
              </button>
              {tabs.slice(paginaActual * 2, paginaActual * 4 + 4).map((tab) => (
                <li
                  key={tab.id}
                  style={{ cursor: "pointer" }}
                  className={
                    pestañaActiva === tab.id
                      ? "nav-item item_activado"
                      : "nav-item"
                  }
                  onClick={() => seleccionarPestaña(tab.id)}
                >
                  <div
                    className="nav-link navSiniestro active"
                    data-toggle="tab"
                    dangerouslySetInnerHTML={{__html:tab.tituloTab}}
                  >
                  </div>
                </li>
              ))}
              <button
                onClick={() => {
                  cambiarPagina(1);
                  seleccionarPestaña(tabs[tabs.length - 1].id);
                }}
                disabled={paginaActual === Math.ceil(tabs.length / 4) - 1}
                className={
                  paginaActual === Math.ceil(tabs.length / 4) - 1
                    ? "button_siniestros button_disabled"
                    : "button_siniestros"
                }
              >
                <ButtonNextSiniestro />
              </button>
            </ul>
          </div>

          <div style={{ background: "var(--gris-claro)" }}>
            <div className="tab-content div-siniestro">
              {tabs.slice(paginaActual * 2, paginaActual * 4 + 4).map((tab) => (
                <div key={tab.id}>
                  {pestañaActiva === tab.id && (
                    <div
                      className={
                        pestañaActiva === tab.id
                          ? "tab-pane container texto__siniestro__div active"
                          : "tab-pane texto__siniestro__div container"
                      }
                    >
                      <br />
                      <ol className=" texto__siniestro list-group-numbered">
                        {contenido
                          .filter((item) => item.idTabSiniestro === tab.id)
                          .map((paso) => (
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                              <div
                                key={paso.id}
                                className="ms-2 me-auto paso__siniestro"
                              >
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: paso.descripcionPaso,
                                  }}
                                ></p>
                              </div>
                            </li>
                          ))}
                      </ol>
                      <p> 
                        En casos extraordinarios si no nos es posible demostrar la procedencia del Evento, 
                        solicitaremos más información sobre los hechos relacionados con éste. 
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Siniestro;
